import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportsAbstractService } from './reports-abstract.service';
import { CustomerSupportSummaryResponse } from '../reports/models/reports';

@Injectable()
export class CustomerSupportReportService extends ReportsAbstractService {
  public reportRoute: string = 'customer_support_report';

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }

  getSummary(params: object): Observable<CustomerSupportSummaryResponse[]> {
    return this.http.post<CustomerSupportSummaryResponse[]>(this.route + '/summary/', params);
  }
}
